import {
  apiRoutes,
  httpClient,
  type PaymentMethodResponse,
} from '@ahm/api-wrappers-core';

export const createVirtualAccount = async (param) => {
  const response = await httpClient.post<PaymentMethodResponse>(
    apiRoutes.payment.virtual_account,
    param
  );

  return response.data;
};
